export default "__VITE_ASSET__CF7U1IC2__"